import ConfigService from "./ConfigService";
import HttpService from "./HttpService";




export default class TranslationService 
{
  constructor(coreDomain) 
  {
    this.configService = new ConfigService();
    this.domain = coreDomain || this.configService.getTranslationServiceHost();

  }

  async fetchVersion(token) 
  {
    const path = "/api/admin/version";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }





    async translateFromTo(fromLang, toLang, txt, gcid, token) 
    {
        const path = "/api/translate/gcid/" + gcid + "/translation/from/" + fromLang + "/to/" + toLang + "/" + txt;
        var response = HttpService.get(this.domain, path, token);
        return response;
    }

    async translateTo(toLang, txt, gcid, token) 
    {
        const path = "/api/translate/gcid/" + gcid + "/translation/to/" + toLang + "/" + txt;
        var response = HttpService.get(this.domain, path, token);
        return response;
    }

}